import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Container,
  Header,
  SpaceBetween,
  Toggle,
  Box,
  Alert,
  ColumnLayout
} from '@amzn/awsui-components-react-v3';
import { RootState } from '../reducers';
import { toggleParentComponentItems } from '../reducers/LabSettingsSlice';

const Lab = () => {
  const dispatch = useDispatch();
  const labSettings = useSelector((state: RootState) => state.labSettingsObj);

  return (
    <div style={{ padding: '2rem' }}>
      <SpaceBetween direction="vertical" size="l">
        <Header variant="h1">Lab Settings</Header>
        
        <Alert type="info">
          Lab settings allow you to enable experimental features that are still in development. 
          These features may not be fully tested and could change or be removed in future releases.
          Settings are stored locally in your browser.
        </Alert>

        <Container
          header={
            <Header variant="h2" description="Enable or disable experimental features">
              Feature Toggles
            </Header>
          }
        >
          <ColumnLayout columns={1}>
            <Box padding={{ vertical: 'm' }}>
              <SpaceBetween direction="vertical" size="xs">
                <Toggle
                  checked={labSettings.parentComponentItems}
                  onChange={() => dispatch(toggleParentComponentItems())}
                >
                  <strong>Service/Related Items</strong>
                </Toggle>
                <Box variant="p" color="text-body-secondary" fontSize="body-s">
                  Enable the ability to create Service Items (Products) that can have Related Items linked to them. 
                  When enabled, you can mark an Item as a "Service" and then link other Items as Related Items. 
                  Service Items will display a "Related Items" tab showing all linked child Items.
                </Box>
              </SpaceBetween>
            </Box>
          </ColumnLayout>
        </Container>

        <Box variant="p" color="text-status-inactive" fontSize="body-s">
          <strong>Note:</strong> Changes take effect immediately. Refresh any open Item pages to see the updated UI.
        </Box>
      </SpaceBetween>
    </div>
  );
};

export default Lab;